

































import { Component, Vue, Prop } from "vue-property-decorator";
import _debug from "debug";
import moment from "moment";

const debug = _debug("Mediacao:components:Chat:Mensagem.vue");

export const enum AlinhamentoMensagem {
    esquerda = 0,
    meio = 2,
    direita = 4,
}

@Component({
    components: {},
})
export default class ChatMessage extends Vue {
    @Prop() public nome!: string;
    @Prop() public mensagem!: string;
    @Prop({ default: 0 }) public alinhamento!: AlinhamentoMensagem;
    @Prop() public tipoUsuario!: string;
    @Prop() public dataHora!: Date;
    @Prop() public arquivoUrl!: string;
    @Prop() public arquivoTipo!: string;

    private classeMensagem: string[] = ["chat-usuario"];
    private async created() {
        debug("ChatMessage.created");
        if (this.tipoUsuario) {
            this.classeMensagem.push(this.tipoUsuario.toLowerCase());
        }
    }

    private get mensagemArquivo(): boolean {
        if (this.arquivoUrl && this.arquivoUrl.length > 0) {
            return true;
        }
        return false;
    }

    private get isArquivoImagem(): boolean {
        return this.arquivoTipo.startsWith("image");
    }

    private get arquivoNome(): string {
        if (this.mensagem.startsWith("arquivo:")) {
            return this.mensagem.replace("arquivo:", "");
        }
        return "";
    }

    private get arquivoLoading(): boolean {
        return this.arquivoUrl === "loading";
    }

    private formataData(data: Date) {
        return moment(data).format("DD/MM/YYYY às HH:mm:ss");
    }
}
